module.exports = __webpack_public_path__ + "img/iso-logo-print.70a4dd3e.gif";